import teacherManagePopup from './teacher-manage/popup';
import materialManagePopup from './material-manage/popup';
import electronicContractPopup from './electronic-contract/popup';
import momentPopup from './moment/popup';

export default [
  ...teacherManagePopup,
  ...materialManagePopup,
  ...electronicContractPopup,
  ...momentPopup,
];
